import React from 'react';
import {view, css, Icon} from '@sail/ui';
import type {Intent} from '@sail/engine';
import {warning} from '@sail/icons/react/Icon';

type Props = {
  id?: string;
  styles?: Intent[];
  showIcon?: boolean;
  dataTestId?: string;
};

export const ErrorMessage: React.FC<Props> = ({
  id,
  children,
  showIcon = false,
  styles = [],
  dataTestId,
}) => (
  <view.span
    id={id}
    uses={[
      css({
        stack: 'x',
        gap: 'xsmall',
        color: 'feedback.critical',
        font: 'label.small',
        wordBreak: 'break-word',
      }),
      ...styles,
    ]}
    data-testid={dataTestId}
  >
    {showIcon && <Icon icon={warning} size="xsmall" />}
    <view.div>{children}</view.div>
  </view.span>
);
